import React                               from 'react';
import { connect }                         from 'react-redux';
import { getPortfolioAction }              from '@/actions/trading';
import { dataType }                        from '@/constants/data-type';
import { getSafe }                         from '@/helpers/global';
import { PARAMS as requestParams }         from '@/constants/params';
import { APP_LANGUAGE_SUPPORTS }           from '@/constants/app';
import { Converter, formatFunctions, utilsFunction } from '@/helpers/functions';
import { colorBindingTypes as colorTypes } from '@/constants/color-binding-type';
import '../../../assets/styles/components/my-account/cash-account-profile-mobile.scss';
import TabHeader from '@/components/TabHeader/TabHeader';
import DefaultRankicon from '@/assets/images/icons/mobiles/sort_normal@2x.png';
import DownRankicon from '@/assets/images/icons/mobiles/sort_des@2x.png';
import DownRankLighticon from '@/assets/images/icons/mobiles/sort_des_light@2x.png';
import RiseRankicon from '@/assets/images/icons/mobiles/sort_asc@2x.png';
import RiseRankLighticon from '@/assets/images/icons/mobiles/sort_asc_light@2x.png';
import arrowDown from '@/assets/images/icons/mobiles/quote_icon_view10details@2x.png'
import { mobileSubLayoutAction } from "@/actions/app/mobileSubLayout.action";
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import NoRow from '@/components/DataTable/CustomNoRow';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY } from '@/constants/app';
import { stockActions } from '@/actions/trading/stock.action';
import classnames from 'classnames'

class PortfolioMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      originData: null,
      market: 'all',
      marketData: [
        {
          label: 'All',
          value: 'all',
        },
        {
          label: 'HK',
          value: 'HKEX',
        },
      ],
      portfolioData: null,
      portfolioTab: [
        { id: 1, title: 'common_all' , value:'ALL'},
        { id: 2, title: 'market_hkex' , value:'HKEX'},
        // { id: 3, title: 'market_mamk', value:'MAMK' },
        // { id: 4, title: 'market_szmk' , value:'SZMK'},
        { id: 3, title: 'market_usex', value:'USEX' },
        { id: 4, title: 'market_stock_connect', value:'CN'},
        { id: 5, title: 'market_funds', value:'FUND'},
      ],
      sortType:null,
      totalMarket:"",
      initialData:'',
      defaultSortData: '',
      load:false,
      selectMarket: 'ALL'
    };
  }

  filterMarket = (val) => {
    const { originData, marketData } = this.state;
    this.setState({
      market: val,
    });
    if (!originData) return;
    let currentData;
    switch (val) {
      case marketData[1].value: {
        currentData = originData.filter(
            (item) => item.marketID === this.state.marketData[1].value
        );
        break;
      }
      default: {
        currentData = originData;
        break;
      }
    }
    this.setState({
      data: currentData,
    });
  };

  getPortfolio = (market) => {
    const { user, tradingAccount, language, mdsToken} = this.props;
    const { clientID } = tradingAccount;
    this.setState({portfolioData:null , load:true})
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      // [requestParams.TRADING_ACC_SEQ]: tradingAccSeq,
      [requestParams.MARKET_ID]: market,
      // [requestParams.CURRENCY_ID]: '',
      // [requestParams.INSTRUMENT_ID]: '',
      // [requestParams.IGNORE_ZERO_TRADABLE_QTY]: 'Y',
      // [requestParams.LIMIT]: -1
    };
    this.props.getAccountPortfolio(params, (res) => {
      let portfoliosData
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        portfoliosData = JSON.parse(JSON.stringify(res.portfoliosList));
        portfoliosData.map(item => {
          item.todayPL = `${formatFunctions.dataFormat(item.todayFloatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.todayFloatingPLPercent)})`  
          if(mdsToken){
            let stockID = item.stockCode.split('').findIndex(i => i !== '0')
            if (stockID > -1) {
              stockID = item.stockCode.substr(stockID)
            }
            const marketID = Converter.mappingWebSocketMarket(item.marketID);

            if(item.marketID === 'USEX'){
              const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
              stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
                item.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                item.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
              })
              stockActions.getStatisticsAction(params, statisticsRes => {
                if(marketID !=='FUND') {
                  item.price = statisticsRes.last
                }
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  item.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                })
              })
            } else {
              const dparams = {
                symbols: [
                  {
                    exchangeID: marketID,
                    key: stockID
                  }
                ],
                sessID:mdsToken
              }
              const params = {
                msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
                symbol: { exchangeID: marketID, key: stockID },
                language: utilsFunction.switchToolTipsLanguage(language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
              }
              this.props.getFinancial(params, financialres => {
                if (financialres && Object.keys(financialres).length) {
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if (quetores.rtnCode) return
                    if (quetores && Object.keys(quetores).length) {
                      item.price = quetores.last;
                      item.bid = quetores.bids?.[0]?.price
                      item.ask = quetores.asks?.[0]?.price
                      item.todayturnover = quetores.turnover
                      item.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                    }
                  })
                }
              })
            }
          }
        })
      }
      this.setState({ 
        portfolioData: portfoliosData,
        totalMarket:res.totalMarket,
        initialData: JSON.parse(JSON.stringify(portfoliosData)),
        defaultSortData: JSON.parse(JSON.stringify(portfoliosData)),
        load:false
      });
    });
  };

    sortWathlist=(sortState)=>{
      if(this.state.portfolioData){
        const { sortType , portfolioData , initialData, defaultSortData} = this.state
        if(sortType !==`${sortState}Rise` && sortType !==`${sortState}Down`){
          this.setState({sortType:`${sortState}Rise`},()=>{
            for ( let i=0;i<portfolioData.length-1;i++){
                for (let j=0;j<portfolioData.length-1-i;j++) {
                      if(Number(portfolioData[j][sortState] && Number(portfolioData[j + 1][sortState]))){
                        if(Number(portfolioData[j][sortState]) >  Number(portfolioData[j + 1][sortState])){
                          let temp = portfolioData[j];
                          portfolioData[j] = portfolioData[j + 1];
                          portfolioData[j + 1] = temp;
                        }
                      }else{
                        if(portfolioData[j][sortState] >  portfolioData[j + 1][sortState]){
                          let temp = portfolioData[j];
                          portfolioData[j] = portfolioData[j + 1];
                          portfolioData[j + 1] = temp;
                        }
                      }
                }
            } 
            this.setState({portfolioData})
          })
        }else if(sortType === `${sortState}Rise`){
          this.setState({sortType:`${sortState}Down`},()=>{
            for ( let i=0;i<portfolioData.length-1;i++){
              for (let j=0;j<portfolioData.length-1-i;j++) {
                if(Number(portfolioData[j][sortState] && Number(portfolioData[j + 1][sortState]))){
                  if(Number(portfolioData[j][sortState]) <  Number(portfolioData[j + 1][sortState])){
                    let temp = portfolioData[j];
                    portfolioData[j] = portfolioData[j + 1];
                    portfolioData[j + 1] = temp;
                  }
                }else{
                  if(portfolioData[j][sortState] <  portfolioData[j + 1][sortState]){
                    let temp = portfolioData[j];
                    portfolioData[j] = portfolioData[j + 1];
                    portfolioData[j + 1] = temp;
                  }
                }
              }
            } 
            this.setState({portfolioData},()=>{
            })
          })
        }else  if(sortType === `${sortState}Down`){
          if(this.state.selectMarket ==='ALL'){
            this.setState({portfolioData : JSON.parse(JSON.stringify(initialData)),sortType:null})
          }else{
            this.setState({portfolioData : JSON.parse(JSON.stringify(defaultSortData)),sortType:null})
          }
        }
      }
  }

  handlefilterProtfolio=(market)=>{
    const {initialData, portfolioData} = this.state
    this.setState({sortType:null})
    let filted;
    if(initialData){
      filted = initialData.filter(item => {
        if(market.main.value === 'ALL'){
          return true
        } else if (market.main.value === 'CN'){
          return item.marketID === 'MAMK' || item.marketID === 'SZMK'
        } else {
          return market.main.value === item.marketID
        }
        // return market.main.value === 'ALL' || market.main.value === item.marketID
      })
    }else{
      filted = null
    }
    this.setState({
      portfolioData : JSON.parse(JSON.stringify(filted)) != '[]' ? JSON.parse(JSON.stringify(filted)) : null,
      defaultSortData : JSON.parse(JSON.stringify(filted)) != '[]' ? JSON.parse(JSON.stringify(filted)) : null,
      selectMarket: market.main.value
    })
  }



  componentDidMount() {
    this.getPortfolio('');
  }

  componentDidUpdate(preProps) {
    const { user , currentTradingAccount } = this.props;
    if (preProps.user !== user) {
      this.getPortfolio('');
    }
    if (preProps.currentTradingAccount !== currentTradingAccount && preProps.currentTradingAccount) {
      this.getPortfolio('');
    }
    if (this.props.isNeedRefresh && this.props.isNeedRefresh !== preProps.isNeedRefresh) {
      this.getPortfolio('')
      const img = document.getElementsByClassName('open-order-btn')
      for(let i=0;i<img.length;i++){
        img[i].style.transform=''
      }
    }
  }

  handleOpenOrderBtn=(e,index)=>{
    const { portfolioData } =this.state
    portfolioData[index].openOrderBtn = !portfolioData[index].openOrderBtn
    this.setState({portfolioData})
  }

  bindingColor=(value)=> {
    if(!value) return;
    const v = value + ""
    if(v?.indexOf('(') != -1){
      if(Number(v?.split('(')[0].replace(/,/g,"")) > 0){
        return 'rise-color'
      }else if(Number(v?.split('(')[0].replace(/,/g,"")) < 0){
        return 'fall-color'
      } else {
        return ''
      }
    }else{
      if(v?.indexOf('%')!= -1){
        if(Number(v?.split('%')[0]) > 0){
          return 'rise-color'
        }else if(Number(v?.split('%')[0]) < 0){
          return 'fall-color'
        } else {
          return ''
        }
      }
    }
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }

  render() {
    const { language , subLayout, theme} = this.props;
    const { portfolioData , portfolioTab , sortType , totalMarket , load, selectMarket} = this.state;
    return (
        <React.Fragment>
          <div className="cash-account-container-profolio flex-items-start bg">
            {<TabHeader tabs={portfolioTab} onChange={this.handlefilterProtfolio} justifyContent={'center'} />}
            {selectMarket === 'FUND' ?  <div className='rank-header-fund'>
                <div onClick={()=>this.sortWathlist('stockCode')}>{language.common_instrument_id}/{language.common_name}<img src={sortType === 'stockCodeRise' ? (theme === 'light' ? RiseRankLighticon : RiseRankicon) :  sortType === 'stockCodeDown' ? (theme === 'light' ? DownRankLighticon : DownRankicon) : DefaultRankicon}/> </div>
                <div onClick={()=>this.sortWathlist('refPrice')} style={{textAlign:'end'}}>{language.common_price}/{language.common_position}<img src={sortType === 'refPriceRise' ? (theme === 'light' ? RiseRankLighticon : RiseRankicon) :  sortType === 'refPriceDown' ? (theme === 'light' ? DownRankLighticon : DownRankicon) : DefaultRankicon}/></div>
            </div>: <div className='rank-header'>
                <div onClick={()=>this.sortWathlist('stockCode')}>{language.common_symbol}/{language.common_name}<img src={sortType === 'stockCodeRise' ? (theme === 'light' ? RiseRankLighticon : RiseRankicon) :  sortType === 'stockCodeDown' ? (theme === 'light' ? DownRankLighticon : DownRankicon) : DefaultRankicon}/> </div>
                <div onClick={()=>this.sortWathlist('marketValue')} style={{textAlign:'end'}}>{language.common_market_value}/{language.common_qty}<img src={sortType === 'marketValueRise' ? (theme === 'light' ? RiseRankLighticon : RiseRankicon) :  sortType === 'marketValueDown' ? (theme === 'light' ? DownRankLighticon : DownRankicon) : DefaultRankicon}/></div>
                <div onClick={()=>this.sortWathlist('refPrice')} style={{textAlign:'end'}}>{language.common_price}/{language.mobile_common_cost}<img src={sortType === 'refPriceRise' ? (theme === 'light' ? RiseRankLighticon : RiseRankicon) :  sortType === 'refPriceDown' ? (theme === 'light' ? DownRankLighticon : DownRankicon) : DefaultRankicon}/></div>
            </div>
            }
            <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
            {portfolioData ? <div className='data-lists' style={{height:'calc(100% - 80px)',overflowY:"auto",overflowX:'hidden'}}>
            {portfolioData?.map((item,index) => {
                    return (
                        <div className="data-list-container bg-box" key={item.stockCode} style={{marginBottom:item.openOrderBtn ? "10px" : "0px"}}>
                            {selectMarket === 'FUND' ? <div className='data-list-fund'>
                              <div className='list-fund-line-one'>
                                <span>{`${Converter.mappingMDSMarketToStock(item.marketID)}.${item.stockCode}`}</span>
                                <span>{formatFunctions.dataFormat(item.refPrice,dataType.STOP_PRICE)}</span>
                              </div>
                              <div className='list-fund-line-two'>
                                <span>{item.stockName}</span>
                                <span>{formatFunctions.dataFormat(item.ledgerQty,dataType.FUNDS_QUANTITY)}</span>
                              </div>
                            </div> : <div className='data-list'>
                                <div className='list-left'>
                                  <div className='left-line-one'>
                                    <span> {`${Converter.mappingMDSMarketToStock(item.marketID)}.${item.stockCode}`}</span>
                                    <span> {formatFunctions.dataFormat(item.marketValue,dataType.CASH)}</span>
                                  </div>
                                  <div className='left-line-two'>
                                    <span> {item.stockName}</span>
                                    <span> {item.marketID === 'FUND' ? formatFunctions.dataFormat(item.ledgerQty,dataType.FUNDS_QUANTITY) 
                                      : formatFunctions.dataFormat(item.ledgerQty,dataType.NUMBER)}</span>
                                  </div>
                                </div>
                                <div className='list-right'>
                                  <div className='price-cost-item'>
                                      <span> {item.marketID === 'FUND' ? formatFunctions.dataFormat(item.refPrice,dataType.STOP_PRICE) 
                                        : formatFunctions.dataFormat(item.refPrice,dataType.CURRENCY)}</span>
                                      <span> {formatFunctions.dataFormat(item.totalAverageCost,dataType.AVG_PRICE)}</span>
                                  </div>
                                </div>
                            </div>}
                            <div className='img-icon'>
                              <img className='open-order-btn' style={item.openOrderBtn ? {transform: 'rotate(180deg)'} : {}} src={arrowDown} onClick={(e)=>this.handleOpenOrderBtn(e,index)} />
                            </div>
                            <div className='pl-price'>
                                <span>{language.mobile_common_pl}</span>
                                <span  style={Converter.colorMapping(colorTypes.UP_DOWN,item.floatingPL)}>
                                    {`${formatFunctions.dataFormat(item.floatingPL,dataType.CASH)}(${formatFunctions.dataFormat(item.floatingPLPercent,dataType.PERCENT)})`}
                                </span>
                            </div>
                            {<div className={classnames('data-trade-container', item.openOrderBtn && theme === 'dark' && 'container-border')}
                            style={{height:item.openOrderBtn ? (selectMarket === 'FUND' ? '140px' : '250px') : '0' , 
                            marginTop:!item.openOrderBtn ? "0" : '10px',
                            marginBottom:!item.openOrderBtn ? "0" : '10px'
                            }}>
                              {selectMarket === 'FUND' ? <div className='data-trade'>
                                  <div className='data-trade-item'>
                                    <span>{language.common_tradable_quantity}</span>
                                    <span>{item.tradableQty ? formatFunctions.dataFormat(item.tradableQty, dataType.FUNDS_QUANTITY) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_today_PL}</span>
                                    <span className={this.bindingColor(item.todayPL)}>{item.todayPL ? item.todayPL : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_ccy}</span>
                                    <span >{item.currencyID ? item.currencyID : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_average_price}</span>
                                    <span>{item.totalAverageCost ? formatFunctions.dataFormat(item.totalAverageCost, dataType.AVG_PRICE) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_market_value}</span>
                                    <span>{item.marketValue ? formatFunctions.dataFormat(item.marketValue,dataType.CASH) : '-'}</span>
                                  </div>
                              </div> : <div className='data-trade'>
                                  <div className='data-trade-item'>
                                    <span>{language.common_change}</span>
                                    <span className={this.bindingColor(item.change)}>{item.change ? item.change : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_bid}</span>
                                    <span>{item.bid ? formatFunctions.dataFormat(item.bid, dataType.CURRENCY) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_ask}</span>
                                    <span>{item.ask ? formatFunctions.dataFormat(item.ask, dataType.CURRENCY) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_tradable_quantity}</span>
                                    <span>
                                      {item.tradableQty ? (item.marketID === 'FUND' ? formatFunctions.dataFormat(item.tradableQty, dataType.FUNDS_QUANTITY) 
                                          : formatFunctions.dataFormat(item.tradableQty, dataType.NUMBER)) 
                                          : '-'}
                                    </span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_today_PL}</span>
                                    <span className={this.bindingColor(item.todayPL)}>{item.todayPL ? item.todayPL : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_ccy}</span>
                                    <span >{item.currencyID ? item.currencyID : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_today_turnover}</span>
                                    <span >{item.todayturnover ? formatFunctions.dataFormat(item.todayturnover, dataType.CASH) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_today_purchase_price}</span>
                                    <span >{item.ttodayConfirmBuy ? formatFunctions.dataFormat(item.ttodayConfirmBuy, dataType.CURRENCY) : '-'}</span>
                                  </div>
                                  <div className='data-trade-item'>
                                    <span>{language.common_today_sales_price}</span>
                                    <span >{item.ttodayConfirmSell ? formatFunctions.dataFormat(item.ttodayConfirmSell, dataType.CURRENCY) : '-'}</span>
                                  </div>
                                </div>}
                            </div>}
                        </div>
                    );
                })}  
            </div>
            : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' , width :'100%'}} />
          }
            
          </div>
        </React.Fragment>
    );
  }


  handleFilter = (val) => {
    this.getPortfolio(val.value);
  }


  handleOpenPlaceOrderDialog = (direction, orderData) => {
    if (this.props.isMobile) {
        orderData.isBuy = direction;
        mobileSubLayoutAction.openPlaceOrder(orderData, true , true);
    } else {
        openPlaceOrderDialog(direction, orderData)
    }
};
}

export default connect(
    (state) => ({
      language: state.app.language,
      user: state.auth.user,
      tradingAccount: state.auth.tradingAccount,
      markets: state.trade.markets,
      isMobile: state.app.isMobile,
      isNeedRefresh: state.refresh.orderTable,
      currentTradingAccount: state.trade.currentTradingAccount,
      mdsToken: state.trade.mdsToken,
      theme: state.app.theme
    }),
    (dispatch) => ({
      getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
      getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
      getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    })
)(PortfolioMobile);
